// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum VehicleMutationTypes {
    SET_VEHICLE = 'SET_VEHICLE',
    SET_VEHICLE_LOADING_PAGE = 'SET_VEHICLE_LOADING_PAGE',
    SET_BIKE = 'SET_BIKE',
  }
  